export default "__VITE_ASSET__B6HZWDS2__"